/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #C5C6C8;
  }
`
export default class FilterArrowIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" css={Color}>
        <g id="그룹_15475" data-name="그룹 15475" transform="translate(-290 -308)">
          <rect id="사각형_9733" data-name="사각형 9733" width="14" height="14" transform="translate(290 308)" fill="red" opacity="0"/>
          <g id="그룹_15474" data-name="그룹 15474" transform="translate(-38.705 221)">
            <path id="합치기_449" className="fill" data-name="합치기 449" d="M12641.7,13135.462l.705-.709,1.623,1.622v-9.79h1v9.793l1.622-1.622.705.706-2.825,2.829Zm-4.669,2.245v-9.792l-1.619,1.621-.709-.709,2.829-2.829,2.829,2.833-.709.705-1.619-1.621v9.792Z" transform="translate(-12305.354 -13038.207)" fill="#c5c6c8"/>
          </g>
        </g>
      </svg>
    )
  }
}
